<h2 mat-dialog-title>Detalle de eficiencia</h2>

<mat-dialog-content>
  @if (is_loading()) {
    <div class="dialog-state">
      <mat-spinner diameter="36"></mat-spinner>
    </div>
  } @else if (error_message()) {
    <div class="dialog-state">
      <p>{{ error_message() }}</p>
    </div>
  } @else {
    @if (view_model(); as view) {
      <div class="detail-header">
        <div>
          <h3>{{ view.title }}</h3>
          <p class="month-label">Periodo {{ view.period_label }}</p>
        </div>
        <div class="summary-value">
          @if (view.summary_real_label && view.summary_expected_label) {
            <span class="efficiency-real" [style.color]="view.summary_color_css">{{ view.summary_real_label }}</span>
            <span class="efficiency-separator">/</span>
            <span class="efficiency-expected">{{ view.summary_expected_label }}</span>
          } @else {
            <span class="efficiency-expected">{{ view.summary_empty_label }}</span>
          }
        </div>
      </div>

      <p class="explanation">{{ view.explanation }}</p>

      <section class="detail-section">
        <h4>Incluidos en el cálculo ({{ view.included.length }})</h4>
        @if (view.included.length === 0) {
          <p class="empty-text">No hay presupuestos incluidos.</p>
        } @else {
          <div class="detail-table-wrap">
            <table class="detail-table">
              <thead>
                <tr>
                  <th>Tarea</th>
                  <th>Categoría</th>
                  <th>Presupuesto</th>
                  <th>Real</th>
                  <th>%</th>
                  <th>Peso</th>
                </tr>
              </thead>
              <tbody>
                @for (item of view.included; track item.task_label + item.category_name) {
                  <tr>
                    <td>{{ item.task_label }}</td>
                    <td>{{ item.category_name }}</td>
                    <td>{{ item.budget_label }}</td>
                    <td>{{ item.real_label }}</td>
                    <td>{{ item.percent_label }}</td>
                    <td>{{ item.contribution_label }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </section>

      <section class="detail-section">
        <h4>Descartados ({{ view.discarded.length }})</h4>
        @if (view.discarded.length === 0) {
          <p class="empty-text">No hay presupuestos descartados.</p>
        } @else {
          <div class="detail-table-wrap">
            <table class="detail-table">
              <thead>
                <tr>
                  <th>Tarea</th>
                  <th>Categoría</th>
                  <th>Presupuesto</th>
                  <th>Real</th>
                  <th>%</th>
                  <th>Motivo</th>
                </tr>
              </thead>
              <tbody>
                @for (item of view.discarded; track item.task_label + item.discard_reason_label) {
                  <tr>
                    <td>{{ item.task_label }}</td>
                    <td>{{ item.category_name }}</td>
                    <td>{{ item.budget_label }}</td>
                    <td>{{ item.real_label }}</td>
                    <td>{{ item.percent_label }}</td>
                    <td class="discard-reason">{{ item.discard_reason_label }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </section>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cerrar</button>
</mat-dialog-actions>
